import Home from '../views/Home.vue'
import Result from '@/views/Result'
import ActivityIndex from '@/views/activity/Index'
import ActivityDetail from '@/views/activity/Detail'
import ActivityAssign from '@/views/activity/Assign'
import ActivityOrderList from '@/views/activity/OrderList'
import ActivityOrderDetail from '@/views/activity/OrderDetail'
import NoticeDetail from '@/views/notice/Detail'
import NewsDetail from '@/views/news/Detail'
import Protocol from '@/views/protocol/Protocol'
import About from '@/views/about/About'
import OpenDoor from '@/views/opendoor/openyourdoor'
import Error404 from '@/views/errorpage/error404'
import RouterViewIndex from '@/components/RouterViewIndex'
import QuestionnaireDetail from '@/views/questionnaire/Detail'
import QuestionnaireRecordDetail from '@/views/questionnaire/RecordDetail'
import VoteDetail from '@/views/vote/Detail'
import VoteRecordDetail from '@/views/vote/RecordDetail'

export const routesNoauth = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/protocol/:type',
    name: 'Protocol',
    component: Protocol
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/result',
    name: 'Result',
    component: Result
  },
  {
    path: "/404",
    name: "Error404",
    component: Error404
  },
]

export const routesAuth = [

  {
    path: '/activity',
    component: ActivityIndex,
    children: [
      {
        path: 'detail/:id',
        name: 'ActivityDetail',
        component: ActivityDetail
      },
      {
        path: 'assign/:id',
        name: 'ActivityAssign',
        component: ActivityAssign
      },
      {
        path: 'order/list',
        name: 'ActivityOrderList',
        component: ActivityOrderList
      },
      {
        path: 'order/detail/:id',
        name: 'ActivityOrderDetail',
        component: ActivityOrderDetail
      }
    ]
  },
  {
    path: '/notice/detail/:id',
    name: 'NoticeDetail',
    component: NoticeDetail
  },
  {
    path: '/news/detail/:id',
    name: 'NewsDetail',
    component: NewsDetail
  },
  {
    path: '/opendoor',
    name: 'Opendoor',
    component: OpenDoor
  },
  {
    path: '/questionnaire',
    component: RouterViewIndex,
    children: [
      {
        path: 'detail/:id',
        name: 'QuestionnaireDetail',
        component: QuestionnaireDetail
      },
      {
        path: 'recorddetail/:id',
        name: 'QuestionnaireRecordDetail',
        component: QuestionnaireRecordDetail
      }
    ]
  },
  {
    path: '/vote',
    component: RouterViewIndex,
    children: [
      {
        path: 'detail/:id',
        name: 'VoteDetail',
        component: VoteDetail
      },
      {
        path: 'recorddetail/:id',
        name: 'VoteRecordDetail',
        component: VoteRecordDetail
      }
    ]
  },
]

export const routesNomatch = [
  {
    path: '*',
    redirect: "/404"
  }
]